import {
  createErrorResource,
  createExternalResource,
  createLoadedResource,
  createLoadingResource,
} from '@next/arable-lib/external-resource';
import { createFeature, createReducer, on } from '@ngrx/store';

import { loadSoilTypes, loadSoilTypesFailed, loadSoilTypesSuccess } from './soil-type.actions';
import { sortByName } from '../helpers/sorters';
import { SoilTypeState } from '../models/soil-type.models';

export const initialState: SoilTypeState = {
  soilTypes: createExternalResource(),
};

export const soilTypeFeature = createFeature({
  name: 'soilType',
  reducer: createReducer(
    initialState,
    on(
      loadSoilTypes,
      (state): SoilTypeState => ({
        ...state,
        soilTypes: createLoadingResource(),
      }),
    ),
    on(
      loadSoilTypesSuccess,
      (state, { payload: { soilTypes } }): SoilTypeState => {
        const sortedSoilTypes = [...soilTypes].sort(sortByName);

        return {
          ...state,
          soilTypes: createLoadedResource(sortedSoilTypes),
        };
      },
    ),
    on(
      loadSoilTypesFailed,
      (state): SoilTypeState => ({
        ...state,
        soilTypes: createErrorResource(),
      }),
    ),
  ),
});

export const { selectSoilTypeState } = soilTypeFeature;
